import $http from '$http'
import {
    lg,
    util
} from 'utils';

export default {
    methods: {
        getInitData(agentId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                agentId: agentId
            };
            $http.get('api/Agent/GetAgentAccountMoneyNew', params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    let Data = res.data.Data;
                    this.form = Data

                });
            });
        },
    }
};


// WEBPACK FOOTER //
// ./src/pages/Agent/hiPackage/components/deviceView/services.js